import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { CtaButton, SecondaryButton, Tag } from "./kit";

export const PLAN_CARDS = [
  { id: "starter", name: "Starter", month: 0, quarter: 0, credits: "100 credits/month",
    features: ["Strategy + Action Plan", "Unlimited scripts and captions", "100 credits/month (≈10 images)"] },
  { id: "founder", name: "Founder", month: 19, quarter: 38, credits: "800 credits/month", highlight: true,
    features: ["Everything in Starter", "800 credits/month (≈80 images)", "7-day trial, no card (250 credits)"] },
  { id: "pro", name: "Pro", month: 49, quarter: 98, credits: "2,500 credits/month",
    features: ["Everything in Founder", "2,500 credits/month (≈250 images)", "7-day trial, no card (400 credits)"] },
  { id: "agency", name: "Agency", contact: true,
    features: ["Custom volumes", "Multiple brands and collaborators", "Dedicated onboarding"] },
];

export const PricingPlans = ({ onSelect, ctaLabel, currentPlan, currentInterval, busyPlan }) => {
  const nav = useNavigate();
  const [interval, setInterval] = useState(currentInterval || "month");
  return (
    <div data-testid="pricing-plans">
      <div className="inline-flex items-center gap-1 bg-[#EFEDE6] rounded-full p-1" data-testid="billing-interval-toggle">
        {[["month", "Monthly"], ["quarter", "Quarterly · 1 month free"]].map(([v, l]) => (
          <button key={v} onClick={() => setInterval(v)}
                  className={`px-4 py-1.5 rounded-full text-[12.5px] font-semibold transition-colors ${interval === v ? "bg-[#181621] text-[#FAF8F3]" : "text-[#54505B]"}`}
                  data-testid={`interval-${v}`}>{l}</button>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 mt-6">
        {PLAN_CARDS.map((p) => (
          <div key={p.id} className={`card-soft p-6 flex flex-col ${p.highlight ? "ring-2 ring-[#181621]" : ""}`} data-testid={`plan-card-${p.id}`}>
            <div className="flex items-center justify-between">
              <span className="font-mono-j text-[11px] tracking-[0.14em] text-[#54505B] uppercase">{p.name}</span>
              {p.highlight && <Tag color="lilac">RECOMMENDED</Tag>}
              {currentPlan === p.id && <Tag color="green">CURRENT</Tag>}
            </div>
            <div className="mt-4 flex items-baseline gap-1.5 min-h-[44px]">
              {p.contact ? (
                <span className="text-2xl font-extrabold tracking-tight text-[#181621]">Talk to sales</span>
              ) : (
                <>
                  <span className="text-4xl font-extrabold tracking-tight text-[#181621]">€{interval === "month" ? p.month : p.quarter}</span>
                  <span className="text-sm text-[#9A9591]">{p.month === 0 ? "" : interval === "month" ? "/month" : "/quarter"}</span>
                </>
              )}
            </div>
            {p.credits && <p className="text-[13px] font-semibold text-[#181621] mt-1">{p.credits}</p>}
            <ul className="mt-5 space-y-2.5 flex-1">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2.5 text-[13px] text-[#181621]">
                  <Check size={15} strokeWidth={1.8} className="text-[#3E7B3E] shrink-0 mt-0.5" />{f}
                </li>
              ))}
            </ul>
            <div className="mt-6">
              {p.contact ? (
                <SecondaryButton className="w-full" onClick={() => nav("/contact?subject=Sales%20inquiry")} data-testid="plan-agency-contact">
                  Contact us
                </SecondaryButton>
              ) : currentPlan === p.id && (!currentInterval || currentInterval === interval) ? (
                <SecondaryButton className="w-full" disabled data-testid={`plan-current-${p.id}`}>Current plan</SecondaryButton>
              ) : (
                <CtaButton className="w-full" disabled={busyPlan === p.id} onClick={() => onSelect(p.id, interval)} data-testid={`plan-select-${p.id}`}>
                  {busyPlan === p.id ? "One moment…" : ctaLabel(p, interval)}
                </CtaButton>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
